import {LinkInput} from '@local/types'
import {Button, Locale, Pastil, SmallText} from '@local/ui/components'
import {cx} from '@local/utils/cx'
import {slugify} from '@local/utils/string'
import React from 'react'

export interface HeaderListProps {
	className?: string
	title: string
	links: LinkInput[] | Array<{ tag?: string; cta: LinkInput, searchParams?: string }>
	useHash?: boolean
}

export const HeaderList = ({className, title, links, useHash = false}: HeaderListProps) => {
	return (
		<div className={cx('flex flex-col gap-20', className)}>
			<SmallText textColor='grey-1'><Locale>{title}</Locale></SmallText>
			<ul className='flex flex-col gap-8'>
				{!!links?.length && links.map((link, index) => {
					const linkCta = link.searchParams
						? {
							...link.cta,
							query: link.searchParams,
						}
						: link.cta
					return (
						<li key={`chapter-${index}`} className='inline-flex items-center'>
							<Button
								variant='underlined'
								className='normal-case tracking-tight text-14 leading-snug'
								href={useHash ? `/#${slugify(link.label || link.cta.label || '')}` : undefined}
								linkInput={useHash ? undefined : linkCta || link}>
								{link.label || link.cta.label}
							</Button>
							{link.tag && (
								<Pastil className='ml-6' variant='grey'>{link.tag}</Pastil>
							)}
						</li>
					)
				})}
			</ul>
		</div>
	)
}
